import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";
import { Button, Message } from "semantic-ui-react";

interface Props extends React.PropsWithChildren {
  title: string
  subTitle?: string
  buttonText: string
  isLoading: boolean
  onSubmit: () => void
  errorMessage?: string
}

const ResetPasswordStep = (props: Props) => {
  const {
    children,
    title, subTitle,
    buttonText, isLoading,
    onSubmit, errorMessage
  } = props;

  return <>
    <div>
      <h2>{title}</h2>
      {subTitle && (<div className="body-text-regular">
        {subTitle}
      </div>)}
    </div>

    {errorMessage &&
      <Message color="red">
        <div className="flex align-center">
          <div className="margin-right">
            <PhosphorWarning />
          </div>
          <div className="grow1">
            <div dangerouslySetInnerHTML={{ __html: errorMessage }} />
          </div>
        </div>
      </Message>
    }

    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
      <div>
        {children}

        <div>
          <Button
            className="button-new"
            type="submit"
            primary
            name="login"
            fluid
            loading={isLoading}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </form>
  </>;
};

export default ResetPasswordStep;
